import React, { useRef, useState, useEffect } from 'react';
import { Toast } from 'primereact/toast';
import '../layout/sass/_responsiveTable.scss';
import '../layout/sass/_dashboard.scss';
import { FileUpload } from 'primereact/fileupload';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { ProgressBar } from 'primereact/progressbar';
import api from '../api/api';

export const FormUpload = ({ visible, setVisible, setLazyParams, Titulo, uploadTipo, listFornecedores }) => {
    const toast = useRef(null);
    const fileUploadRef = useRef(null);
    const [disabled, setDisabled] = useState(false);
    const [progressVisible, setProgressVisible] = useState(false);
    const [arquivoNome, setArquivoNome] = useState('');
    const [fornecedorSelecionado, setFornecedorSelecionado] = useState(null);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [selecionar] = useState({ label: 'Selecionar', icon: 'pi pi-fw pi-plus', className: '' });
    const [enviar] = useState({ label: 'Enviar', icon: 'pi pi-upload' });
    const [cancelar] = useState({ label: 'Cancelar', icon: 'pi pi-times' });

    const handleClear = () => {
        console.log('Limpando estado do FormUpload');
        setDisabled(false);
        setArquivoNome('');
        setFornecedorSelecionado(null);
        setSelectedFiles([]);
        setProgressVisible(false);
    };

    const handleSelect = (e) => {
        console.log('Evento onSelect disparado:', e.files);
        if (e.files && e.files.length > 0) {
            setSelectedFiles([...e.files]); // Clonar FileList para array
            setArquivoNome(e.files[0].name);
            setDisabled(false); // Habilitar botões Enviar/Cancelar
        } else {
            setSelectedFiles([]);
            setArquivoNome('');
            setDisabled(false);
        }
    };

    const handlerUpload = async (event) => {
        console.log('Iniciando handlerUpload, selectedFiles:', selectedFiles, 'uploadTipo:', uploadTipo);
        if (!fornecedorSelecionado) {
            console.log('Fornecedor não selecionado');
            toast.current.show({
                life: 3000,
                severity: 'error',
                summary: 'Erro ao enviar',
                detail: 'Selecione um fornecedor antes de enviar o arquivo.',
            });
            setDisabled(false);
            return;
        }

        const files = event.files || selectedFiles;
        if (files.length === 0) {
            console.log('Nenhum arquivo selecionado');
            toast.current.show({
                life: 3000,
                severity: 'error',
                summary: 'Erro ao enviar',
                detail: 'Nenhum arquivo selecionado.',
            });
            setDisabled(false);
            return;
        }

        setDisabled(true);
        setProgressVisible(true);

        let hasError = false;
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            console.log('Processando arquivo:', file.name);
            const extensao = file.name.split('.').pop().toLowerCase();
            const extensoesPermitidas = uploadTipo === '0' ? ['txt', 'csv'] : ['xml', 'csv'];
            console.log('Extensões permitidas:', extensoesPermitidas, 'Extensão do arquivo:', extensao);
            if (!extensoesPermitidas.includes(extensao)) {
                console.log('Extensão inválida:', extensao);
                toast.current.show({
                    life: 3000,
                    severity: 'error',
                    summary: 'Erro ao enviar',
                    detail: `Extensão de arquivo inválida para "${file.name}". Use: ${extensoesPermitidas.join(', ')}`,
                });
                hasError = true;
                continue;
            }

            const formData = new FormData();
            formData.append('file', file);
            formData.append('userEmail', 'user@example.com'); // Substitua pelo email do usuário autenticado
            formData.append('fornecedorId', fornecedorSelecionado.id);

            console.log('FormData preparado:', {
                file: file.name,
                userEmail: 'user@example.com',
                fornecedorId: fornecedorSelecionado.id,
                fornecedorCod: fornecedorSelecionado.cod,
            });
            console.log('FormData entries:', [...formData.entries()]);

            try {
                let response;
                if (uploadTipo === '0') {
                    console.log('Enviando para /pdf/extrairEmpenhos');
                    response = await api.post('/pdf/extrairEmpenhos', formData);
                } else if (fornecedorSelecionado.cod === 'Algar') {
                    console.log('Enviando para /pdf/extrairAlgar');
                    response = await api.post('/pdf/extrairAlgar', formData);
                } else if (fornecedorSelecionado.cod === 551) {
                    console.log('Enviando para /pdf/extrairCemig');
                    response = await api.post('/pdf/extrairCemig', formData);
                } else if (fornecedorSelecionado.cod === 41048) {
                    console.log('Enviando para /pdf/extrairCopasa');
                    response = await api.post('/pdf/extrairCopasa', formData);
                } else {
                    console.log('Código do fornecedor inválido:', fornecedorSelecionado.cod);
                    throw new Error('Código do fornecedor inválido.');
                }

                console.log(`Upload bem-sucedido para ${file.name}:`, response.data);
                toast.current.show({
                    life: 3000,
                    severity: 'success',
                    summary: 'Sucesso',
                    detail: `Arquivo "${file.name}" enviado com sucesso!`,
                });
            } catch (error) {
                console.error(`Erro na API para ${file.name}:`, error);
                const errorMessage =
                    error.response?.data?.message ||
                    error.response?.data?.error ||
                    error.message ||
                    'Erro desconhecido ao processar o arquivo.';
                toast.current.show({
                    life: 5000,
                    severity: 'error',
                    summary: 'Erro ao enviar arquivo',
                    detail: errorMessage,
                });
                hasError = true;
            }
        }

        console.log('Finalizando upload, reativando interações');
        setProgressVisible(false);
        setDisabled(false);
        if (fileUploadRef.current) {
            console.log('Chamando fileUploadRef.current.clear()');
            fileUploadRef.current.clear();
        }

        if (!hasError) {
            console.log('Fechando diálogo após upload bem-sucedido');
            setTimeout(() => {
                setVisible(false);
                setLazyParams({
                    first: 0,
                    rows: 20,
                    sortField: null,
                    sortOrder: null,
                    filters: {},
                });
            }, 2000);
        }
    };

    useEffect(() => {
        console.log('Diálogo visível:', visible, 'uploadTipo:', uploadTipo);
        if (visible) {
            handleClear(); // Limpar estado ao abrir o diálogo
        }
    }, [visible]);

    return (
        <Dialog
            visible={visible}
            onHide={() => {
                console.log('Fechando diálogo');
                setVisible(false);
                handleClear();
            }}
            className="p-scrollpanel-bar-y"
            breakpoints={{ '960px': '75vw', '640px': '100vw' }}
            style={{ width: '50vw', height: 'auto' }}
            header={Titulo}
        >
            <Toast ref={toast} position="bottom-right" />
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-12 p-xl-12">
                    <div className="p-field p-col-12 p-sm-12">
                        <label>{Titulo}</label>
                        {uploadTipo === '1' && (
                            <div className="card flex justify-content-center">
                                <Dropdown
                                    value={fornecedorSelecionado}
                                    onChange={(e) => {
                                        console.log('Fornecedor selecionado:', e.value);
                                        setFornecedorSelecionado(e.value);
                                    }}
                                    options={listFornecedores}
                                    optionLabel="nome"
                                    placeholder="Selecione um Fornecedor"
                                    className="w-full md:w-14rem"
                                    disabled={disabled}
                                />
                            </div>
                        )}
                        <FileUpload
                            ref={fileUploadRef}
                            customUpload
                            accept={uploadTipo === '0' ? '.txt,.csv' : '.xml,.csv'}
                            uploadHandler={handlerUpload}
                            chooseOptions={selecionar}
                            uploadOptions={enviar}
                            cancelOptions={cancelar}
                            onClear={() => {
                                console.log('Limpando FileUpload via onClear');
                                handleClear();
                            }}
                            onRemove={() => {
                                console.log('Removendo arquivo');
                                setDisabled(false);
                                setArquivoNome('');
                                setSelectedFiles([]);
                            }}
                            onSelect={handleSelect}
                            multiple
                            disabled={disabled}
                        />
                        <ProgressBar mode="indeterminate" style={{ display: progressVisible ? 'block' : 'none' }} />
                    </div>
                </div>
            </div>
        </Dialog>
    );
};